let playButtons, pauseButtons, autoplayVideos, lazyVideoObserver;

function init_videos(){
	console.log('function loaded');
	
	if (window.init_videos_initialized) {
			destroy_videos();
	}
	
	autoplayVideos = [].slice.call(document.querySelectorAll("video.autoplay"));
	//console.log(autoplayVideos);
	
	if ("IntersectionObserver" in window) {
		lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(video) {
				if (video.isIntersecting) {
					for (var source in video.target.children) {
						var videoSource = video.target.children[source];
						if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
							videoSource.src = videoSource.dataset.src;							
						}
					}
	
					video.target.load();
					video.target.classList.remove("autoplay");
					lazyVideoObserver.unobserve(video.target);
					video.target.play();
				}
			});
		});
	
		autoplayVideos.forEach(function(autoplayVideo) {
			lazyVideoObserver.observe(autoplayVideo);
		});
	}
	
	playButtons = document.querySelectorAll('.video-play-button');
	pauseButtons = document.querySelectorAll('.video-pause-button');
	
	playButtons.forEach(button => button.addEventListener("click", handlePlayButtonClick));	
	pauseButtons.forEach(button => button.addEventListener("click", handlePauseButtonClick));

	window.init_videos_initialized = true;
}

function handlePlayButtonClick(event) {
	const button = event.currentTarget;
	const videoWrap = button.closest('.video-wrap');
	const video = videoWrap.querySelector('video');
	const videoPause = videoWrap.querySelector('.video-pause-button');
	
	//console.log(video);
	if (video) {
		const videoSources = video.querySelectorAll('source');
		videoSources.forEach(source => {
			// Assuming data-src attribute exists on the video element
			source.src = source.dataset.src;
		});
		video.load();			
		video.play();
		video.setAttribute("controls","controls")
	}
	button.style.display = 'none';
	
	if (videoPause) {
		videoPause.style.display = 'flex';
	}
}

function handlePauseButtonClick(event) {
		const button = event.currentTarget;
		const videoWrap = button.closest('.video-wrap');
		const video = videoWrap.querySelector('video');
		const videoPlay = videoWrap.querySelector('.video-play-button');
		const videoOverlay = videoWrap.querySelector('.video-overlay');

		if (video) {
				video.pause();
		}
		button.style.display = 'none';
		videoOverlay.style.display = 'flex';
}

function destroy_videos() {
	if (playButtons) {
			playButtons.forEach(button => button.removeEventListener("click", handlePlayButtonClick));
	}
	
	// Remove event listeners from pauseButtons
	if (pauseButtons) {
			pauseButtons.forEach(button => button.removeEventListener("click", handlePauseButtonClick));
	}
	
	// Disconnect IntersectionObserver
	if (lazyVideoObserver) {
			lazyVideoObserver.disconnect();
	}
	
	// Clear variable references
	playButtons = null;
	pauseButtons = null;
	autoplayVideos = null;
	lazyVideoObserver = null;
	
	// Unset initialization flag
	window.init_videos_initialized = false;
}

window.init_videos = init_videos;

document.addEventListener("DOMContentLoaded", function() {
	init_videos();
});